var React = require('react');

function IcCheck24px (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z","key":1})]);
}

IcCheck24px.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IcCheck24px;

IcCheck24px.default = IcCheck24px;
